<template>
  <div id=app>
    <div class=outer>
      <h2>名车车标展示-鼠标移过显示车标</h2>
      <ul>
        <li  v-for="(item,index) in lists" :key=item.title :class="{zindex:item.isActive}">
          <a href=# :title=item.title
          @mouseover="handleAover(index)"
          @mouseout="handleAout(index)"
          ><strong>{{item.name}}</strong>{{item.val}}</a>
          <img
          @mouseover="handleAover(index)"
          @mouseout="handleAout(index)"
           :class="{current:item.isActive}" :src=item.src :alt=item.title>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      lists:[
        {
          title:'BMW 宝马汽车',
          name:'BMW',
          val:'宝马汽车',
          src:require('./assets/lesson2/1.jpg'),
          isActive:false,
        },

        {
          title:'Alfa Romeo 阿尔法-罗米欧',
          name:'Alfa Romeo',
          val:'阿尔法-罗米欧',
          src:require('./assets/lesson2/2.jpg'),
          isActive:false,
        },

        {
          title:'Skoda 斯柯达',
          name:'Skoda',
          val:'斯柯达',
          src:require('./assets/lesson2/3.jpg'),
          isActive:false,
        },

        {
          title:'Volkswagen 大众汽车',
          name:'Volkswagen',
          val:'大众汽车',
          src:require('./assets/lesson2/4.jpg'),
          isActive:false
        },

        {
          title:'Saab 萨布牌轿',
          name:'Saab',
          val:'萨布牌轿',
          src:require('./assets/lesson2/5.jpg'),
          isActive:false,
        },

        {
          title:'Lamborghini 兰博基尼',
          name:'Lamborghini',
          val:'兰博基尼',
          src:require('./assets/lesson2/6.jpg'),
          isActive:false,
        },

        {
          title:'Porsche 保时捷',
          name:'Porsche',
          val:'保时捷',
          src:require('./assets/lesson2/7.jpg'),
          isActive:false,
        },

        {
          title:'Peugeot 标致',
          name:'Peugeot',
          val:'标致',
          src:require('./assets/lesson2/8.jpg'),
          isActive:false,
        },

        {
          title:'Mercedes1 梅赛德斯 奔驰',
          name:'Mercedes1',
          val:'梅赛德斯 奔驰',
          src:require('./assets/lesson2/9.jpg'),
          isActive:false,
        },

        {
          title:'Buick 别克汽车',
          name:'Buick',
          val:'别克汽车',
          src:require('./assets/lesson2/10.jpg'),
          isActive:false,
        }
      ]
    }
  },
  methods:{
    handleAover(index){
      this.lists[index].isActive=true;

},
    handleAout(index){
      this.lists[index].isActive=false;

}
  }
}
</script>
<style>
        body, div, h2, ul, li {
            margin: 0;
            padding: 0;
        }

        body {
            font: 12px/1.5 Tahoma;
        }

        ul {
            list-style-type: none;
        }

        .outer {
            width: 560px;
            border: 1px solid #333;
            margin: 10px auto;
            padding: 0 0 10px 10px;
        }

            .outer h2 {
                line-height: 30px;
                text-align: center;
                margin-top: 10px;
            }

            .outer ul:after {
                content: ".";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
            }

            .outer ul {
                zoom: 1;
            }

                .outer ul li {
                    position: relative;
                    float: left;
                    border: 1px solid #333;
                    margin: 10px 10px 0 0;
                    display: inline;
                }

                    .outer ul li img {
                        position: absolute;
                        top: -14px;
                        left: -14px;
                        display: none;
                        border: 2px solid #999;
                        cursor: crosshair;
                    }

                    .outer ul li img.current {
                      display: block;
                    }
                    .outer ul li a {
                        color: #666;
                        width: 80px;
                        height: 80px;
                        display: block;
                        background: #f0f0f0;
                        text-decoration: none;
                        padding: 10px;
                    }

                        .outer ul li a strong {
                            display: block;
                        }

        .zindex {
            z-index: 1;
        }

</style>
